export const getProductDataReview = ({ formulaReviewWizard }) => formulaReviewWizard.productDataReview;
